export const GET_INSTANCE_WAIT_DURATION = 2500;
